export const editorDownloadEvent = (props: {
  btnLabel: string;
  mpvId: string;
  localizedProductName: string;
  coreProductId: string;
  isFromTab: boolean;
  trackingFunc: (eventName: string, callback: Function, counter?: number) => void;
}) => {
  const { btnLabel, mpvId, localizedProductName, coreProductId, isFromTab, trackingFunc } = props;
  const eventName = "Button Clicked";

  trackingFunc(eventName, () => {
    (window as any).tracking.track(eventName, {
      category: "Product Page",
      label: btnLabel,
      eventDetail: isFromTab ? "Tab" : "Top",
      pageSection: "Product Page",
      pageStage: "Discover",
      pageName: `${mpvId}:Product Page`,
      product_id: mpvId,
      name: localizedProductName,
      core_product_id: coreProductId,
    });
  });
};
